import React from "react";
import { usePermissions } from "../../../hooks/usePermissions";
import type { Resource } from "../../../types/permissions";

interface PlansTabNavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

interface PlanTab {
  id: string;
  label: string;
  resource: Resource;
}

const ALL_TABS: PlanTab[] = [
  { id: "meal",        label: "Meal",        resource: "meal_plan" },
  { id: "water",       label: "Water",       resource: "water_plan" },
  { id: "exercise",    label: "Exercise",    resource: "exercise_plan" },
  { id: "supplements", label: "Supplements", resource: "supplement_plan" },
  { id: "guidelines",  label: "Guidelines",  resource: "guideline" },
];

const PlansTabNavigation: React.FC<PlansTabNavigationProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { can } = usePermissions();
  const tabs = ALL_TABS.filter((tab) => can(tab.resource, "view"));

  return (
    <div className="flex gap-1.5">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`px-4 py-1.5 rounded-[40px] font-inter font-medium text-[12px] 3xl:text-sm transition-all ${
            activeTab === tab.id
              ? "bg-[#1F1F1F] text-white"
              : "bg-white text-[#1F1F1F] border border-[#E0E0E0] hover:border-[#1F1F1F]"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PlansTabNavigation;
